<template>
  <v-container fluid>
    <v-layout wrap>
      <iframe width="100%" height="1200" :src="this.$route.query.link"></iframe>
    </v-layout>
  </v-container>
</template>

<script>
import { http } from '@/axios';

import { mapMutations } from 'vuex';

export default {
  name: 'Camera',
  data() {
    return {};
  },
  props: ['info', 'solicitudId'],
  computed: {
    link: function () {
      // extraigo el link del texto
      if (this.info.includes('Link Güeno')) {
        return this.info.substring(11);
      } else if (this.info.includes('Link Firma DigitalMinds')) {
        return this.info.substring(25);
      } else if (this.info.includes('Link Firma CardCred')) {
        return this.info.substring(21);
      } else {
        return this.info; // se supone viene el link directamente
      }
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    OnSelectCam(link) {
      this.link = link;
    },

    async copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        console.log('Clipboard no habilitado');
        return;
      }
      navigator.clipboard.writeText(text).then(
        function () {
          console.log('Async: Copying to clipboard was successful!');
        },
        function (err) {
          console.error('Async: Could not copy text: ', err);
        }
      );
    },
    async sendLink() {
      var params = {};
      params.creditoId = this.solicitudId;
      params.link = this.link;

      try {
        await http.post('enviosms/linklegajogueno', JSON.stringify(params));

        this.alertSuccess('Se ha enviado el SMS.');
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
  },
};
</script>
